<app-rp-edit
  [validatePasswordResetResponse]="validatePasswordResetResponse"
  [headerToken]="headerToken"
  (resetPasswordOutput)="getresetPasswordSuccessData($event)"
  *ngIf="!submitted && validatePasswordResetResponse"
></app-rp-edit>
<app-rp-confirmation *ngIf="submitted"></app-rp-confirmation>
